var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"consensus-icon",class:_vm.consensus},[(_vm.consensus === 'syncing')?_c('WorldIcon'):(_vm.consensus === 'established')?_c('WorldCheckIcon'):_c('WorldAlertIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }